import React from "react";
import { connect } from "react-redux";
import { Button, Form, Icon, Modal } from "semantic-ui-react";
import { FormProvider } from "react-hook-form";
import OfficerFormModalAction from "../../redux/actions/OfficerFormModalAction";
import useOfficerFormModal from "../hooks/useOfficerFormModal";
import OfficerDetailsForm from "../shared/forms/OfficerDetailsForm";

const OfficerFormModal = (props) => {
  const { open, title, searchQuery, officerFormData } = props.data;

  const { methods, closeModal, onSubmit } = useOfficerFormModal({
    officerFormData,
    searchQuery,
  });

  return (
    <Modal open={open} onClose={closeModal} size="small" centered={false}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <FormProvider {...methods}>
          <Form id="officerForm" onSubmit={methods.handleSubmit(onSubmit)}>
            <OfficerDetailsForm />
          </Form>
        </FormProvider>
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" floated="left" onClick={closeModal} color="blue">
          <Icon name="arrow left" />
          Back
        </Button>
        <Button
          type="submit"
          disabled={!methods.formState.isValid}
          form="officerForm"
          color="green"
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    data: OfficerFormModalAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(OfficerFormModal);
